import { Routes } from '@angular/router';

import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';
import { VisualizarLinksCompartilhadosComponent } from './links-compartilhados/visualizar-links-compartilhados/visualizar-links-compartilhados.component';
import { PublicAccessGuard } from './_services/autenticacao/public-access.service';

export const AppRoutes: Routes = [
  {
    path: '',
    //redirectTo: 'not-found404',
    redirectTo: 'listar-indicadores',
    pathMatch: 'full',
  },
  {
    path: '',
    component: AdminLayoutComponent,
    children:
      [
        {
          path: '',
          loadChildren: './_components/not-found/not-found.module#NotFoundModule'
        },
        {
          path: '',
          loadChildren: './_components/index-home/index-home.module#IndexHomeModule'
        },
        {
          path: '',
          loadChildren: './modulos/modulos.module#ModulosModule'
        },
        {
          path: '',
          loadChildren: './clientes/clientes.module#ClientesModule'
        },
        {
          path: '',
          loadChildren: './usuarios/usuarios.module#UsuariosModule'
        },
        {
          path: '',
          loadChildren: './monitoracao/monitoracao.module#MonitoracaoModule'
        },
        {
          path: '',
          loadChildren: './eventos/eventos.module#EventosModule'
        },
        {
          path: '',
          loadChildren: './tipo-evento/tipo-evento.module#TipoEventoModule'
        },
        {
          path: '',
          loadChildren: './origem/origem.module#OrigemModule'
        },
        {
          path: '',
          loadChildren: './origem-filho/origem-filho.module#OrigemFilhoModule'
        },
        {
          path: '',
          loadChildren: './grupo/grupo.module#GrupoModule'
        },
        {
          path: '',
          loadChildren: './destinatario/destinatario.module#DestinatarioModule'
        },
        {
          path: '',
          loadChildren: './alarme/alarme.module#AlarmeModule'
        },
        {
          path: '',
          loadChildren: './alarme-alias/alarme-alias.module#AlarmeAliasModule'
        },
        {
          path: '',
          loadChildren: './agendamento/agendamento.module#AgendamentoModule'
        },
        {
          path: '',
          loadChildren: './restricao/restricao.module#RestricaoModule'
        },
        {
          path: '',
          loadChildren: './ocorrencia/ocorrencia.module#OcorrenciaModule'
        },
        {
          path: '',
          loadChildren: './tipo-ocorrencia/tipo-ocorrencia.module#TipoOcorrenciaModule'
        },
        {
          path: '',
          loadChildren: './auditor/auditor.module#AuditorModule'
        },
        {
          path: '',
          loadChildren: './visualizacao/visualizacao.module#VisualizacaoModule'
        },
        {
          path: '',
          loadChildren: './visualizacao-grupo-item/visualizacao-grupo-item.module#VisualizacaoGrupoItemModule'
        },
        {
          path: '',
          loadChildren: './configuracao-email/configuracao-email.module#ConfiguracaoEmailModule'
        },
        {
          path: '',
          loadChildren: './remetente/remetente.module#RemetenteModule'
        },
        {
          path: '',
          loadChildren: './hardware-grupo/hardware-grupo.module#HardwareGrupoModule'
        },
        {
          path: '',
          loadChildren: './painel/painel.module#PainelModule'
        },
        {
          path: '',
          loadChildren: './configuracao-sistema/configuracao-sistema.module#ConfiguracaoSistemaModule'
        },
        {
          path: '',
          loadChildren: './servico/servico.module#ServicoModule'
        },
        {
          path: '',
          loadChildren: './admin/admin.module#AdminModule'
        },
        {
          path: '',
          loadChildren: './report-conexao/report-conexao.module#ReportConexaoModule'
        },
        {
          path: '',
          loadChildren: './report-grupo/report-grupo.module#ReportGrupoModule'
        },
        {
          path: '',
          loadChildren: './report/report.module#ReportModule'
        },
        {
          path: '',
          loadChildren: './report-perfil-filtro/report-perfil-filtro.module#ReportPerfilFiltroModule'
        },
        {
          path: '',
          loadChildren: './meu-perfil/meu-perfil.module#MeuPerfilModule'
        },
        {
          path: '',
          loadChildren: './administrativo/administrativo.module#AdministrativoModule'
        },
        {
          path: '',
          loadChildren: './conciliacao/conciliacao.module#ConciliacaoModule'
        },
        {
          path: '',
          loadChildren: './indicadores/indicadores.module#IndicadoresModule'
        },
        {
          path: '',
          loadChildren: './links-compartilhados/links-compartilhados.module#LinksCompartilhadosModule'
        }
      ]
  },
  {
    path: '',
    component: AuthLayoutComponent,
    children: [{
      path: 'pages',
      loadChildren: './pages/pages.module#PagesModule'
    }]
  }
];
